import {BaseDomainService} from "../../../infrastructure/domain-services/base-domain-service";
import {BaseManagedService} from "../../../infrastructure/domain-services/base-managed-service";
import {DomainRequestManager} from "../../../core/managers/domain-request-manager";
import {StandingsRepository} from "./standings.repository";
import {StandingsFactory} from "./standings.factory";

export class StandingsDomainService extends BaseDomainService {
  static injectables = [...BaseManagedService.injectables, StandingsRepository, StandingsFactory, DomainRequestManager];
}
